import { render } from "./ImportErrorModal.vue?vue&type=template&id=16bd9fe6&scoped=true"
import script from "./ImportErrorModal.vue?vue&type=script&lang=js"
export * from "./ImportErrorModal.vue?vue&type=script&lang=js"

import "./ImportErrorModal.vue?vue&type=style&index=0&id=16bd9fe6&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bd9fe6"]])

export default __exports__